// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/view/v1/view.proto (package penumbra.view.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Address, AddressIndex, AddressView, IdentityKey, WalletId } from "../../core/keys/v1/keys_pb.js";
import { AuctionId, DutchAuctionDescription } from "../../core/component/auction/v1/auction_pb.js";
import { BatchSwapOutputData, Position, PositionId, PositionState, Reserves, SwapPlaintext, TradingPair } from "../../core/component/dex/v1/dex_pb.js";
import { AuthorizationData, MemoPlaintext, Transaction, TransactionPerspective, TransactionPlan, TransactionView, WitnessData } from "../../core/transaction/v1/transaction_pb.js";
import { TransactionId } from "../../core/txhash/v1/txhash_pb.js";
import { IbcRelay, Ics20Withdrawal } from "../../core/component/ibc/v1/ibc_pb.js";
import { Fee, FeeTier, GasPrices } from "../../core/component/fee/v1/fee_pb.js";
import { CommitmentSource, Epoch, Nullifier } from "../../core/component/sct/v1/sct_pb.js";
import { AssetId, Denom, Metadata, Value, ValueView } from "../../core/asset/v1/asset_pb.js";
import { StateCommitment } from "../../crypto/tct/v1/tct_pb.js";
import { Amount } from "../../core/num/v1/num_pb.js";
import { Penalty, RateData } from "../../core/component/stake/v1/stake_pb.js";
import { Vote } from "../../core/component/governance/v1/governance_pb.js";
import { AppParameters } from "../../core/app/v1/app_pb.js";
import { FmdParameters, Note } from "../../core/component/shielded_pool/v1/shielded_pool_pb.js";

/**
 * Filters in an `AuctionsRequest` will be combined using `AND` logic -- that
 * is, the more filters you add, the fewer responses you're likely to get.
 *
 * @generated from message penumbra.view.v1.AuctionsRequest
 */
export const AuctionsRequest = proto3.makeMessageType(
  "penumbra.view.v1.AuctionsRequest",
  () => [
    { no: 1, name: "account_filter", kind: "message", T: AddressIndex },
    { no: 2, name: "include_inactive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "query_latest_state", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "auction_ids_filter", kind: "message", T: AuctionId, repeated: true },
  ],
);

/**
 * @generated from message penumbra.view.v1.AuctionsResponse
 */
export const AuctionsResponse = proto3.makeMessageType(
  "penumbra.view.v1.AuctionsResponse",
  () => [
    { no: 1, name: "id", kind: "message", T: AuctionId },
    { no: 2, name: "auction", kind: "message", T: Any },
    { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
    { no: 4, name: "note_record", kind: "message", T: SpendableNoteRecord },
    { no: 5, name: "local_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.AuthorizeAndBuildRequest
 */
export const AuthorizeAndBuildRequest = proto3.makeMessageType(
  "penumbra.view.v1.AuthorizeAndBuildRequest",
  () => [
    { no: 1, name: "transaction_plan", kind: "message", T: TransactionPlan },
  ],
);

/**
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse
 */
export const AuthorizeAndBuildResponse = proto3.makeMessageType(
  "penumbra.view.v1.AuthorizeAndBuildResponse",
  () => [
    { no: 1, name: "build_progress", kind: "message", T: AuthorizeAndBuildResponse_BuildProgress, oneof: "status" },
    { no: 2, name: "complete", kind: "message", T: AuthorizeAndBuildResponse_Complete, oneof: "status" },
  ],
);

/**
 * Signals that building is in progress.
 *
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse.BuildProgress
 */
export const AuthorizeAndBuildResponse_BuildProgress = proto3.makeMessageType(
  "penumbra.view.v1.AuthorizeAndBuildResponse.BuildProgress",
  () => [
    { no: 1, name: "progress", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "AuthorizeAndBuildResponse_BuildProgress"},
);

/**
 * Signals that the transaction is complete.
 *
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse.Complete
 */
export const AuthorizeAndBuildResponse_Complete = proto3.makeMessageType(
  "penumbra.view.v1.AuthorizeAndBuildResponse.Complete",
  () => [
    { no: 1, name: "transaction", kind: "message", T: Transaction },
  ],
  {localName: "AuthorizeAndBuildResponse_Complete"},
);

/**
 * @generated from message penumbra.view.v1.BroadcastTransactionRequest
 */
export const BroadcastTransactionRequest = proto3.makeMessageType(
  "penumbra.view.v1.BroadcastTransactionRequest",
  () => [
    { no: 1, name: "transaction", kind: "message", T: Transaction },
    { no: 2, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse
 */
export const BroadcastTransactionResponse = proto3.makeMessageType(
  "penumbra.view.v1.BroadcastTransactionResponse",
  () => [
    { no: 1, name: "broadcast_success", kind: "message", T: BroadcastTransactionResponse_BroadcastSuccess, oneof: "status" },
    { no: 2, name: "confirmed", kind: "message", T: BroadcastTransactionResponse_Confirmed, oneof: "status" },
  ],
);

/**
 * Signals that the transaction was broadcast successfully (but has not been confirmed).
 *
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse.BroadcastSuccess
 */
export const BroadcastTransactionResponse_BroadcastSuccess = proto3.makeMessageType(
  "penumbra.view.v1.BroadcastTransactionResponse.BroadcastSuccess",
  () => [
    { no: 1, name: "id", kind: "message", T: TransactionId },
  ],
  {localName: "BroadcastTransactionResponse_BroadcastSuccess"},
);

/**
 * Signals that the transaction has been confirmed on-chain and detected by the view server.
 *
 * Will not be sent unless await_detection was true.
 *
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse.Confirmed
 */
export const BroadcastTransactionResponse_Confirmed = proto3.makeMessageType(
  "penumbra.view.v1.BroadcastTransactionResponse.Confirmed",
  () => [
    { no: 1, name: "id", kind: "message", T: TransactionId },
    { no: 2, name: "detection_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "BroadcastTransactionResponse_Confirmed"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest
 */
export const TransactionPlannerRequest = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest",
  () => [
    { no: 1, name: "expiry_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "memo", kind: "message", T: MemoPlaintext },
    { no: 4, name: "source", kind: "message", T: AddressIndex },
    { no: 20, name: "outputs", kind: "message", T: TransactionPlannerRequest_Output, repeated: true },
    { no: 21, name: "spends", kind: "message", T: TransactionPlannerRequest_Spend, repeated: true },
    { no: 30, name: "swaps", kind: "message", T: TransactionPlannerRequest_Swap, repeated: true },
    { no: 31, name: "swap_claims", kind: "message", T: TransactionPlannerRequest_SwapClaim, repeated: true },
    { no: 40, name: "delegations", kind: "message", T: TransactionPlannerRequest_Delegate, repeated: true },
    { no: 50, name: "undelegations", kind: "message", T: TransactionPlannerRequest_Undelegate, repeated: true },
    { no: 51, name: "undelegation_claims", kind: "message", T: TransactionPlannerRequest_UndelegateClaim, repeated: true },
    { no: 60, name: "ibc_relay_actions", kind: "message", T: IbcRelay, repeated: true },
    { no: 61, name: "ics20_withdrawals", kind: "message", T: Ics20Withdrawal, repeated: true },
    { no: 70, name: "position_opens", kind: "message", T: TransactionPlannerRequest_PositionOpen, repeated: true },
    { no: 71, name: "position_closes", kind: "message", T: TransactionPlannerRequest_PositionClose, repeated: true },
    { no: 72, name: "position_withdraws", kind: "message", T: TransactionPlannerRequest_PositionWithdraw, repeated: true },
    { no: 73, name: "dutch_auction_schedule_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionSchedule, repeated: true },
    { no: 74, name: "dutch_auction_end_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionEnd, repeated: true },
    { no: 75, name: "dutch_auction_withdraw_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionWithdraw, repeated: true },
    { no: 76, name: "delegator_votes", kind: "message", T: TransactionPlannerRequest_DelegatorVote, repeated: true },
    { no: 100, name: "auto_fee", kind: "message", T: FeeTier, oneof: "fee_mode" },
    { no: 101, name: "manual_fee", kind: "message", T: Fee, oneof: "fee_mode" },
    { no: 200, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 201, name: "epoch", kind: "message", T: Epoch },
  ],
);

/**
 * Request message subtypes
 *
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Output
 */
export const TransactionPlannerRequest_Output = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.Output",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "address", kind: "message", T: Address },
  ],
  {localName: "TransactionPlannerRequest_Output"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Spend
 */
export const TransactionPlannerRequest_Spend = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.Spend",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "address", kind: "message", T: Address },
  ],
  {localName: "TransactionPlannerRequest_Spend"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Swap
 */
export const TransactionPlannerRequest_Swap = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.Swap",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "target_asset", kind: "message", T: AssetId },
    { no: 3, name: "fee", kind: "message", T: Fee },
    { no: 4, name: "claim_address", kind: "message", T: Address },
  ],
  {localName: "TransactionPlannerRequest_Swap"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.SwapClaim
 */
export const TransactionPlannerRequest_SwapClaim = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.SwapClaim",
  () => [
    { no: 1, name: "swap_commitment", kind: "message", T: StateCommitment },
  ],
  {localName: "TransactionPlannerRequest_SwapClaim"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Delegate
 */
export const TransactionPlannerRequest_Delegate = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.Delegate",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 3, name: "rate_data", kind: "message", T: RateData },
  ],
  {localName: "TransactionPlannerRequest_Delegate"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Undelegate
 */
export const TransactionPlannerRequest_Undelegate = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.Undelegate",
  () => [
    { no: 1, name: "value", kind: "message", T: Value },
    { no: 2, name: "rate_data", kind: "message", T: RateData },
  ],
  {localName: "TransactionPlannerRequest_Undelegate"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.UndelegateClaim
 */
export const TransactionPlannerRequest_UndelegateClaim = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.UndelegateClaim",
  () => [
    { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
    { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "penalty", kind: "message", T: Penalty },
    { no: 4, name: "unbonding_amount", kind: "message", T: Amount },
    { no: 5, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "TransactionPlannerRequest_UndelegateClaim"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionOpen
 */
export const TransactionPlannerRequest_PositionOpen = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.PositionOpen",
  () => [
    { no: 1, name: "position", kind: "message", T: Position },
  ],
  {localName: "TransactionPlannerRequest_PositionOpen"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionClose
 */
export const TransactionPlannerRequest_PositionClose = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.PositionClose",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
  ],
  {localName: "TransactionPlannerRequest_PositionClose"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionWithdraw
 */
export const TransactionPlannerRequest_PositionWithdraw = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.PositionWithdraw",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
    { no: 2, name: "reserves", kind: "message", T: Reserves },
    { no: 3, name: "trading_pair", kind: "message", T: TradingPair },
  ],
  {localName: "TransactionPlannerRequest_PositionWithdraw"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionSchedule
 */
export const TransactionPlannerRequest_ActionDutchAuctionSchedule = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionSchedule",
  () => [
    { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
  ],
  {localName: "TransactionPlannerRequest_ActionDutchAuctionSchedule"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionEnd
 */
export const TransactionPlannerRequest_ActionDutchAuctionEnd = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionEnd",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
  ],
  {localName: "TransactionPlannerRequest_ActionDutchAuctionEnd"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionWithdraw
 */
export const TransactionPlannerRequest_ActionDutchAuctionWithdraw = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionWithdraw",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "TransactionPlannerRequest_ActionDutchAuctionWithdraw"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.DelegatorVote
 */
export const TransactionPlannerRequest_DelegatorVote = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerRequest.DelegatorVote",
  () => [
    { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "vote", kind: "message", T: Vote },
    { no: 3, name: "start_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "rate_data", kind: "message", T: RateData, repeated: true },
  ],
  {localName: "TransactionPlannerRequest_DelegatorVote"},
);

/**
 * @generated from message penumbra.view.v1.TransactionPlannerResponse
 */
export const TransactionPlannerResponse = proto3.makeMessageType(
  "penumbra.view.v1.TransactionPlannerResponse",
  () => [
    { no: 1, name: "plan", kind: "message", T: TransactionPlan },
  ],
);

/**
 * @generated from message penumbra.view.v1.AddressByIndexRequest
 */
export const AddressByIndexRequest = proto3.makeMessageType(
  "penumbra.view.v1.AddressByIndexRequest",
  () => [
    { no: 1, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from message penumbra.view.v1.AddressByIndexResponse
 */
export const AddressByIndexResponse = proto3.makeMessageType(
  "penumbra.view.v1.AddressByIndexResponse",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
  ],
);

/**
 * @generated from message penumbra.view.v1.WalletIdRequest
 */
export const WalletIdRequest = proto3.makeMessageType(
  "penumbra.view.v1.WalletIdRequest",
  [],
);

/**
 * @generated from message penumbra.view.v1.WalletIdResponse
 */
export const WalletIdResponse = proto3.makeMessageType(
  "penumbra.view.v1.WalletIdResponse",
  () => [
    { no: 1, name: "wallet_id", kind: "message", T: WalletId },
  ],
);

/**
 * @generated from message penumbra.view.v1.IndexByAddressRequest
 */
export const IndexByAddressRequest = proto3.makeMessageType(
  "penumbra.view.v1.IndexByAddressRequest",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
  ],
);

/**
 * @generated from message penumbra.view.v1.IndexByAddressResponse
 */
export const IndexByAddressResponse = proto3.makeMessageType(
  "penumbra.view.v1.IndexByAddressResponse",
  () => [
    { no: 1, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from message penumbra.view.v1.EphemeralAddressRequest
 */
export const EphemeralAddressRequest = proto3.makeMessageType(
  "penumbra.view.v1.EphemeralAddressRequest",
  () => [
    { no: 1, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from message penumbra.view.v1.EphemeralAddressResponse
 */
export const EphemeralAddressResponse = proto3.makeMessageType(
  "penumbra.view.v1.EphemeralAddressResponse",
  () => [
    { no: 1, name: "address", kind: "message", T: Address },
  ],
);

/**
 * @generated from message penumbra.view.v1.BalancesRequest
 */
export const BalancesRequest = proto3.makeMessageType(
  "penumbra.view.v1.BalancesRequest",
  () => [
    { no: 1, name: "account_filter", kind: "message", T: AddressIndex },
    { no: 2, name: "asset_id_filter", kind: "message", T: AssetId },
  ],
);

/**
 * @generated from message penumbra.view.v1.BalancesResponse
 */
export const BalancesResponse = proto3.makeMessageType(
  "penumbra.view.v1.BalancesResponse",
  () => [
    { no: 1, name: "account", kind: "message", T: AddressIndex },
    { no: 2, name: "balance", kind: "message", T: Value },
    { no: 3, name: "account_address", kind: "message", T: AddressView },
    { no: 4, name: "balance_view", kind: "message", T: ValueView },
  ],
);

/**
 * Requests sync status of the view service.
 *
 * @generated from message penumbra.view.v1.StatusRequest
 */
export const StatusRequest = proto3.makeMessageType(
  "penumbra.view.v1.StatusRequest",
  [],
);

/**
 * Returns the status of the view service and whether it is synchronized with the chain state.
 *
 * @generated from message penumbra.view.v1.StatusResponse
 */
export const StatusResponse = proto3.makeMessageType(
  "penumbra.view.v1.StatusResponse",
  () => [
    { no: 1, name: "full_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "partial_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "catching_up", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Requests streaming updates on the sync height until the view service is synchronized.
 *
 * @generated from message penumbra.view.v1.StatusStreamRequest
 */
export const StatusStreamRequest = proto3.makeMessageType(
  "penumbra.view.v1.StatusStreamRequest",
  [],
);

/**
 * A streaming sync status update
 *
 * @generated from message penumbra.view.v1.StatusStreamResponse
 */
export const StatusStreamResponse = proto3.makeMessageType(
  "penumbra.view.v1.StatusStreamResponse",
  () => [
    { no: 1, name: "latest_known_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "full_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "partial_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * A query for notes known by the view service.
 *
 * This message uses the fact that all proto fields are optional
 * to allow various filtering on the returned notes.
 *
 * @generated from message penumbra.view.v1.NotesRequest
 */
export const NotesRequest = proto3.makeMessageType(
  "penumbra.view.v1.NotesRequest",
  () => [
    { no: 2, name: "include_spent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "asset_id", kind: "message", T: AssetId },
    { no: 4, name: "address_index", kind: "message", T: AddressIndex },
    { no: 6, name: "amount_to_spend", kind: "message", T: Amount },
  ],
);

/**
 * A query for notes to be used for voting on a proposal.
 *
 * @generated from message penumbra.view.v1.NotesForVotingRequest
 */
export const NotesForVotingRequest = proto3.makeMessageType(
  "penumbra.view.v1.NotesForVotingRequest",
  () => [
    { no: 1, name: "votable_at_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from message penumbra.view.v1.WitnessRequest
 */
export const WitnessRequest = proto3.makeMessageType(
  "penumbra.view.v1.WitnessRequest",
  () => [
    { no: 3, name: "transaction_plan", kind: "message", T: TransactionPlan },
  ],
);

/**
 * @generated from message penumbra.view.v1.WitnessResponse
 */
export const WitnessResponse = proto3.makeMessageType(
  "penumbra.view.v1.WitnessResponse",
  () => [
    { no: 1, name: "witness_data", kind: "message", T: WitnessData },
  ],
);

/**
 * @generated from message penumbra.view.v1.WitnessAndBuildRequest
 */
export const WitnessAndBuildRequest = proto3.makeMessageType(
  "penumbra.view.v1.WitnessAndBuildRequest",
  () => [
    { no: 1, name: "transaction_plan", kind: "message", T: TransactionPlan },
    { no: 2, name: "authorization_data", kind: "message", T: AuthorizationData },
  ],
);

/**
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse
 */
export const WitnessAndBuildResponse = proto3.makeMessageType(
  "penumbra.view.v1.WitnessAndBuildResponse",
  () => [
    { no: 1, name: "build_progress", kind: "message", T: WitnessAndBuildResponse_BuildProgress, oneof: "status" },
    { no: 2, name: "complete", kind: "message", T: WitnessAndBuildResponse_Complete, oneof: "status" },
  ],
);

/**
 * Signals that building is in progress.
 *
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse.BuildProgress
 */
export const WitnessAndBuildResponse_BuildProgress = proto3.makeMessageType(
  "penumbra.view.v1.WitnessAndBuildResponse.BuildProgress",
  () => [
    { no: 1, name: "progress", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "WitnessAndBuildResponse_BuildProgress"},
);

/**
 * Signals that the transaction is complete.
 *
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse.Complete
 */
export const WitnessAndBuildResponse_Complete = proto3.makeMessageType(
  "penumbra.view.v1.WitnessAndBuildResponse.Complete",
  () => [
    { no: 1, name: "transaction", kind: "message", T: Transaction },
  ],
  {localName: "WitnessAndBuildResponse_Complete"},
);

/**
 * Requests all assets known to the view service.
 *
 * @generated from message penumbra.view.v1.AssetsRequest
 */
export const AssetsRequest = proto3.makeMessageType(
  "penumbra.view.v1.AssetsRequest",
  () => [
    { no: 1, name: "filtered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "include_specific_denominations", kind: "message", T: Denom, repeated: true },
    { no: 3, name: "include_delegation_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "include_unbonding_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "include_lp_nfts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "include_proposal_nfts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "include_voting_receipt_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Requests all assets known to the view service.
 *
 * @generated from message penumbra.view.v1.AssetsResponse
 */
export const AssetsResponse = proto3.makeMessageType(
  "penumbra.view.v1.AssetsResponse",
  () => [
    { no: 2, name: "denom_metadata", kind: "message", T: Metadata },
  ],
);

/**
 * Requests the current app parameters from the view service.
 *
 * @generated from message penumbra.view.v1.AppParametersRequest
 */
export const AppParametersRequest = proto3.makeMessageType(
  "penumbra.view.v1.AppParametersRequest",
  [],
);

/**
 * @generated from message penumbra.view.v1.AppParametersResponse
 */
export const AppParametersResponse = proto3.makeMessageType(
  "penumbra.view.v1.AppParametersResponse",
  () => [
    { no: 1, name: "parameters", kind: "message", T: AppParameters },
  ],
);

/**
 * Requests the current gas prices from the view service.
 *
 * @generated from message penumbra.view.v1.GasPricesRequest
 */
export const GasPricesRequest = proto3.makeMessageType(
  "penumbra.view.v1.GasPricesRequest",
  [],
);

/**
 * @generated from message penumbra.view.v1.GasPricesResponse
 */
export const GasPricesResponse = proto3.makeMessageType(
  "penumbra.view.v1.GasPricesResponse",
  () => [
    { no: 1, name: "gas_prices", kind: "message", T: GasPrices },
    { no: 2, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
  ],
);

/**
 * Requests the current FMD parameters from the view service.
 *
 * @generated from message penumbra.view.v1.FMDParametersRequest
 */
export const FMDParametersRequest = proto3.makeMessageType(
  "penumbra.view.v1.FMDParametersRequest",
  [],
);

/**
 * @generated from message penumbra.view.v1.FMDParametersResponse
 */
export const FMDParametersResponse = proto3.makeMessageType(
  "penumbra.view.v1.FMDParametersResponse",
  () => [
    { no: 1, name: "parameters", kind: "message", T: FmdParameters },
  ],
);

/**
 * @generated from message penumbra.view.v1.NoteByCommitmentRequest
 */
export const NoteByCommitmentRequest = proto3.makeMessageType(
  "penumbra.view.v1.NoteByCommitmentRequest",
  () => [
    { no: 2, name: "note_commitment", kind: "message", T: StateCommitment },
    { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.NoteByCommitmentResponse
 */
export const NoteByCommitmentResponse = proto3.makeMessageType(
  "penumbra.view.v1.NoteByCommitmentResponse",
  () => [
    { no: 1, name: "spendable_note", kind: "message", T: SpendableNoteRecord },
  ],
);

/**
 * @generated from message penumbra.view.v1.SwapByCommitmentRequest
 */
export const SwapByCommitmentRequest = proto3.makeMessageType(
  "penumbra.view.v1.SwapByCommitmentRequest",
  () => [
    { no: 2, name: "swap_commitment", kind: "message", T: StateCommitment },
    { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.SwapByCommitmentResponse
 */
export const SwapByCommitmentResponse = proto3.makeMessageType(
  "penumbra.view.v1.SwapByCommitmentResponse",
  () => [
    { no: 1, name: "swap", kind: "message", T: SwapRecord },
  ],
);

/**
 * @generated from message penumbra.view.v1.UnclaimedSwapsRequest
 */
export const UnclaimedSwapsRequest = proto3.makeMessageType(
  "penumbra.view.v1.UnclaimedSwapsRequest",
  [],
);

/**
 * @generated from message penumbra.view.v1.UnclaimedSwapsResponse
 */
export const UnclaimedSwapsResponse = proto3.makeMessageType(
  "penumbra.view.v1.UnclaimedSwapsResponse",
  () => [
    { no: 1, name: "swap", kind: "message", T: SwapRecord },
  ],
);

/**
 * @generated from message penumbra.view.v1.NullifierStatusRequest
 */
export const NullifierStatusRequest = proto3.makeMessageType(
  "penumbra.view.v1.NullifierStatusRequest",
  () => [
    { no: 2, name: "nullifier", kind: "message", T: Nullifier },
    { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.NullifierStatusResponse
 */
export const NullifierStatusResponse = proto3.makeMessageType(
  "penumbra.view.v1.NullifierStatusResponse",
  () => [
    { no: 1, name: "spent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.TransactionInfoByHashRequest
 */
export const TransactionInfoByHashRequest = proto3.makeMessageType(
  "penumbra.view.v1.TransactionInfoByHashRequest",
  () => [
    { no: 2, name: "id", kind: "message", T: TransactionId },
  ],
);

/**
 * @generated from message penumbra.view.v1.TransactionInfoRequest
 */
export const TransactionInfoRequest = proto3.makeMessageType(
  "penumbra.view.v1.TransactionInfoRequest",
  () => [
    { no: 1, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.view.v1.TransactionInfo
 */
export const TransactionInfo = proto3.makeMessageType(
  "penumbra.view.v1.TransactionInfo",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "id", kind: "message", T: TransactionId },
    { no: 3, name: "transaction", kind: "message", T: Transaction },
    { no: 4, name: "perspective", kind: "message", T: TransactionPerspective },
    { no: 5, name: "view", kind: "message", T: TransactionView },
  ],
);

/**
 * @generated from message penumbra.view.v1.TransactionInfoResponse
 */
export const TransactionInfoResponse = proto3.makeMessageType(
  "penumbra.view.v1.TransactionInfoResponse",
  () => [
    { no: 1, name: "tx_info", kind: "message", T: TransactionInfo },
  ],
);

/**
 * @generated from message penumbra.view.v1.TransactionInfoByHashResponse
 */
export const TransactionInfoByHashResponse = proto3.makeMessageType(
  "penumbra.view.v1.TransactionInfoByHashResponse",
  () => [
    { no: 1, name: "tx_info", kind: "message", T: TransactionInfo },
  ],
);

/**
 * @generated from message penumbra.view.v1.NotesResponse
 */
export const NotesResponse = proto3.makeMessageType(
  "penumbra.view.v1.NotesResponse",
  () => [
    { no: 1, name: "note_record", kind: "message", T: SpendableNoteRecord },
  ],
);

/**
 * @generated from message penumbra.view.v1.NotesForVotingResponse
 */
export const NotesForVotingResponse = proto3.makeMessageType(
  "penumbra.view.v1.NotesForVotingResponse",
  () => [
    { no: 1, name: "note_record", kind: "message", T: SpendableNoteRecord },
    { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
  ],
);

/**
 * A note plaintext with associated metadata about its status.
 *
 * @generated from message penumbra.view.v1.SpendableNoteRecord
 */
export const SpendableNoteRecord = proto3.makeMessageType(
  "penumbra.view.v1.SpendableNoteRecord",
  () => [
    { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "note", kind: "message", T: Note },
    { no: 3, name: "address_index", kind: "message", T: AddressIndex },
    { no: 4, name: "nullifier", kind: "message", T: Nullifier },
    { no: 5, name: "height_created", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "height_spent", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "source", kind: "message", T: CommitmentSource },
    { no: 9, name: "return_address", kind: "message", T: AddressView },
  ],
);

/**
 * @generated from message penumbra.view.v1.SwapRecord
 */
export const SwapRecord = proto3.makeMessageType(
  "penumbra.view.v1.SwapRecord",
  () => [
    { no: 1, name: "swap_commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "swap", kind: "message", T: SwapPlaintext },
    { no: 3, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "nullifier", kind: "message", T: Nullifier },
    { no: 5, name: "output_data", kind: "message", T: BatchSwapOutputData },
    { no: 6, name: "height_claimed", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "source", kind: "message", T: CommitmentSource },
  ],
);

/**
 * @generated from message penumbra.view.v1.OwnedPositionIdsRequest
 */
export const OwnedPositionIdsRequest = proto3.makeMessageType(
  "penumbra.view.v1.OwnedPositionIdsRequest",
  () => [
    { no: 1, name: "position_state", kind: "message", T: PositionState },
    { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
  ],
);

/**
 * @generated from message penumbra.view.v1.OwnedPositionIdsResponse
 */
export const OwnedPositionIdsResponse = proto3.makeMessageType(
  "penumbra.view.v1.OwnedPositionIdsResponse",
  () => [
    { no: 1, name: "position_id", kind: "message", T: PositionId },
  ],
);

/**
 * Requests information on an asset by asset id
 *
 * @generated from message penumbra.view.v1.AssetMetadataByIdRequest
 */
export const AssetMetadataByIdRequest = proto3.makeMessageType(
  "penumbra.view.v1.AssetMetadataByIdRequest",
  () => [
    { no: 2, name: "asset_id", kind: "message", T: AssetId },
  ],
);

/**
 * @generated from message penumbra.view.v1.AssetMetadataByIdResponse
 */
export const AssetMetadataByIdResponse = proto3.makeMessageType(
  "penumbra.view.v1.AssetMetadataByIdResponse",
  () => [
    { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
  ],
);

/**
 * Requests `ValueView`s of delegation tokens for the given address index. The
 * returned `ValueView`s will include the `ValidatorInfo` for the delegated
 * validator in their `extended_metadata` fields.
 *
 * @generated from message penumbra.view.v1.DelegationsByAddressIndexRequest
 */
export const DelegationsByAddressIndexRequest = proto3.makeMessageType(
  "penumbra.view.v1.DelegationsByAddressIndexRequest",
  () => [
    { no: 1, name: "address_index", kind: "message", T: AddressIndex },
    { no: 2, name: "filter", kind: "enum", T: proto3.getEnumType(DelegationsByAddressIndexRequest_Filter) },
  ],
);

/**
 * @generated from enum penumbra.view.v1.DelegationsByAddressIndexRequest.Filter
 */
export const DelegationsByAddressIndexRequest_Filter = proto3.makeEnum(
  "penumbra.view.v1.DelegationsByAddressIndexRequest.Filter",
  [
    {no: 0, name: "FILTER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FILTER_ALL_ACTIVE_WITH_NONZERO_BALANCES", localName: "ALL_ACTIVE_WITH_NONZERO_BALANCES"},
    {no: 2, name: "FILTER_ALL", localName: "ALL"},
  ],
);

/**
 * Contains a `ValueView` of delegation tokens for the requested address index.
 * The `ValueView` includes the `ValidatorInfo` for the delegated validator in
 * cits `extended_metadata` field.
 *
 * @generated from message penumbra.view.v1.DelegationsByAddressIndexResponse
 */
export const DelegationsByAddressIndexResponse = proto3.makeMessageType(
  "penumbra.view.v1.DelegationsByAddressIndexResponse",
  () => [
    { no: 1, name: "value_view", kind: "message", T: ValueView },
  ],
);

/**
 * Requests unbonding tokens for a given address index, with optional filtering
 * for whether the tokens are currently claimable.
 *
 * @generated from message penumbra.view.v1.UnbondingTokensByAddressIndexRequest
 */
export const UnbondingTokensByAddressIndexRequest = proto3.makeMessageType(
  "penumbra.view.v1.UnbondingTokensByAddressIndexRequest",
  () => [
    { no: 1, name: "filter", kind: "enum", T: proto3.getEnumType(UnbondingTokensByAddressIndexRequest_Filter) },
    { no: 2, name: "address_index", kind: "message", T: AddressIndex },
  ],
);

/**
 * @generated from enum penumbra.view.v1.UnbondingTokensByAddressIndexRequest.Filter
 */
export const UnbondingTokensByAddressIndexRequest_Filter = proto3.makeEnum(
  "penumbra.view.v1.UnbondingTokensByAddressIndexRequest.Filter",
  [
    {no: 0, name: "FILTER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FILTER_CLAIMABLE", localName: "CLAIMABLE"},
    {no: 2, name: "FILTER_NOT_YET_CLAIMABLE", localName: "NOT_YET_CLAIMABLE"},
  ],
);

/**
 * Returns unbonding tokens for the given address index, optionally filtered by
 * whether the tokens are currently claimable.
 *
 * @generated from message penumbra.view.v1.UnbondingTokensByAddressIndexResponse
 */
export const UnbondingTokensByAddressIndexResponse = proto3.makeMessageType(
  "penumbra.view.v1.UnbondingTokensByAddressIndexResponse",
  () => [
    { no: 1, name: "value_view", kind: "message", T: ValueView },
    { no: 2, name: "claimable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

